import classes from './modal.module.css';

export const modalTheme = {
  classNames: {
    inner: classes.inner,
    content: classes.content,
    header: classes.header,
    title: classes.title,
    body: classes.body,
    close: classes.close,
    overlay: classes.overlay,
  },
};
